import {Box, Button, IconButton, PaletteMode, Popover, Typography, useTheme} from '@mui/material';
import {useTranslation} from 'react-i18next';
import SelectArrowIcon from '@icons/SelectArrowIcon';
import {useState, useContext} from 'react';
import HeaderWithIcons from '@components/app/HeaderWithIcons';
import {ProjectContext} from '@context/ProjectContext';
import AddIcon from '@icons/AddIcon';
import MinesIcon from '@icons/MinesIcon';


export default function Settings() {
	const {t, i18n} = useTranslation();
	const theme = useContext(ProjectContext);
	const muiTheme = useTheme();
	const [anchorLang, setAnchorLang] = useState<HTMLButtonElement | null>(null);
	const [anchorTheme, setAnchorTheme] = useState<HTMLButtonElement | null>(null);
	
	const handleOpenLang = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorLang(event.currentTarget);
	};
	
	const handleCloseLang = () => {
		setAnchorLang(null);
	};
	
	const openLang = Boolean(anchorLang);
	
	
	const changeLanguage = (lang: string) => {
		localStorage.setItem('lang', lang);
		i18n.changeLanguage(lang);
		handleCloseLang();
	};
	
	const handleOpenTheme = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorTheme(event.currentTarget);
	};
	
	const handleCloseTheme = () => {
		setAnchorTheme(null);
	};
	
	const openTheme = Boolean(anchorTheme);
	
	
	const changeTheme = (t: PaletteMode) => {
		localStorage.setItem('theme', t);
		theme.setTheme(t);
		handleCloseTheme();
	};
	
	const addFontSize = () => {
		if (muiTheme.typography.fontSize < 25) {
			const size = muiTheme.typography.fontSize + 1;
			localStorage.setItem('font_size', `${size}`);
			theme.setFontSize(size);
		}
	};
	
	const reduceFontSize = () => {
		if (muiTheme.typography.fontSize > 8) {
			const size = muiTheme.typography.fontSize - 1;
			localStorage.setItem('font_size', `${size}`);
			theme.setFontSize(size);
		}
	};
	
	
	return (
		<>
			<HeaderWithIcons title={t('settings')}/>
			<div className="flex flex-col space-y-2 px-4">
				
				<Box
					sx={{bgcolor: (theme) => theme.palette.mode === 'light' ? 'secondary.100' : theme.palette.background.paper}}
					className="rounded flex flex-row h-14 items-center px-4">
					<Typography sx={{color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.100'}}
					            className="grow w-0 font-medium">{t('change_language')}</Typography>
					<Button sx={{color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.100'}} className="-mx-1"
					        onClick={handleOpenLang} endIcon={<SelectArrowIcon/>}>
						{
							// @ts-ignore
							t(i18n.language)
						}
					</Button>
					<Popover
						open={openLang}
						anchorEl={anchorLang}
						onClose={handleCloseLang}
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'left'
						}}
					>
						<div className="flex flex-col w-24 py-2 space-y-4">
							{
								// @ts-ignore
								Object.keys(i18n.options.resources).map(lang => <Button
									fullWidth
									disabled={i18n.language === lang}
									onClick={() => changeLanguage(lang)}>
									{
										// @ts-ignore
										t(lang)
									}
								</Button>)
							}
						</div>
					</Popover>
				</Box>
				<Box
					sx={{bgcolor: (theme) => theme.palette.mode === 'light' ? 'secondary.100' : theme.palette.background.paper}}
					className="rounded flex flex-row h-14 items-center px-4">
					<Typography sx={{color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.100'}}
					            className="grow w-0 font-medium">{t('change_theme')}</Typography>
					<Button sx={{color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.100'}} className="-mx-1"
					        onClick={handleOpenTheme} endIcon={<SelectArrowIcon/>}>
						{
							// @ts-ignore
							t(theme.theme)
						}
					</Button>
					<Popover
						open={openTheme}
						anchorEl={anchorTheme}
						onClose={handleCloseTheme}
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'left'
						}}
					>
						<div className="flex flex-col w-24 py-2 space-y-4">
							<Button
								sx={{color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.200'}}
								fullWidth
								onClick={() => changeTheme('dark')}>
								{t('dark')}
							</Button>
							<Button
								sx={{color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.200'}}
								fullWidth
								onClick={() => changeTheme('light')}>
								{t('light')}
							</Button>
						</div>
					</Popover>
				</Box>
				<Box className="rounded flex flex-row h-14 items-center ">
					<Typography sx={{color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.100'}}
					            className="grow w-0 font-medium">{t('change_font_size')}</Typography>
					<div className="flex flex-row items-center">
						<IconButton onClick={addFontSize} className="mx-2">
							<AddIcon/>
						</IconButton>
						<Typography className="text-center" minWidth={24}>{muiTheme.typography.fontSize}</Typography>
						<IconButton onClick={reduceFontSize} className="mx-2">
							<MinesIcon/>
						</IconButton>
					</div>
				</Box>
			</div>
		</>
	);
}
